module.exports = __webpack_public_path__ + "img/OT814.aa36774.webp";